import React from 'react';
import { movdTokens } from '../design-system/movdTokens.js';

const projects = [
  { title: 'Downtown Toronto Condo Move', description: 'A seamless move for a family of four from North York to a downtown Toronto condo, including packing, transport, and setup.', image: '/assets/assets/img/portfolio1.jpg' },
  { title: 'Montreal Tech Startup Office Relocation', description: 'Movd handled the full relocation of a 30-person tech office, including IT equipment and furniture, with zero downtime.', image: '/assets/assets/img/portfolio2.jpg' },
  { title: 'Long-Distance Move: Vancouver to Calgary', description: 'A cross-province move for a couple, including vehicle transport and secure storage for two weeks.', image: '/assets/assets/img/portfolio3.jpg' },
  { title: 'Student Move: Ottawa', description: 'Affordable, quick move-in for a university student, including packing and assembly.', image: '/assets/assets/img/portfolio4.jpg' },
];

export default function Portfolio() {
  return (
    <main style={{ padding: 32 }}>
      <h1 style={{ margin: '0 0 8px', fontSize: 32, fontWeight: 900 }}>Our portfolio</h1>
      <p style={{ marginBottom: 32, fontSize: 16 }}>See highlights from our recent moves and success stories across Canada.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24 }}>
        {projects.map(proj => (
          <div key={proj.title} style={{ padding: 16, borderRadius: 12, boxShadow: movdTokens.shadow.raised, background: '#fff', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <img src={proj.image} alt={`Portfolio project: ${proj.title}`} loading="lazy" style={{ width: '100%', borderRadius: 8, objectFit: 'cover', height: 160 }} />
            <h2 style={{ margin: 0, fontSize: 19, fontWeight: 700 }}>{proj.title}</h2>
            <p style={{ margin: 0, fontSize: 14, color: movdTokens.color.content.secondary }}>{proj.description}</p>
          </div>
        ))}
      </div>
    </main>
  );
}
